var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-backtop',{attrs:{"target":_vm.target}},[_c('i',{staticClass:"el-icon-top",staticStyle:{"margin-top":"4px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }